/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // Broadcast's mobile-sliderule never updates aria-expanded after init. A trigger click
  // always opens its panel, and back, Escape, and drawer close all lower the pane depth.
  // The panel's is-visible class is skipped because it sticks if another row opens
  // before the exit animation ends.
  const initialisedPanes = new WeakSet();

  function init(root) {
    const panes = [...root.querySelectorAll("[data-sliderule-pane]")];
    if (root.matches?.("[data-sliderule-pane]")) panes.unshift(root);
    for (const pane of panes) {
      if (initialisedPanes.has(pane)) continue;
      initialisedPanes.add(pane);

      pane.addEventListener("click", (event) => {
        event.target.closest("[data-sliderule-open]")?.setAttribute("aria-expanded", "true");
      });

      new MutationObserver(() => {
        const depth = Number(pane.dataset.sliderulePane);
        for (const sliderule of pane.querySelectorAll("mobile-sliderule")) {
          const panel = sliderule.querySelector("[data-sliderule]");
          if (Number(panel?.dataset.sliderule) > depth) {
            sliderule
              .querySelector(`[data-sliderule-open="${sliderule.id}"]`)
              ?.setAttribute("aria-expanded", "false");
          }
        }
      }).observe(pane, { attributeFilter: ["data-sliderule-pane"] });
    }
  }

  init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();

(function () {
  // Vendor bundles rewrite [data-product-price] innerHTML without the visually
  // hidden sale/regular names: product-info.js on variant or quantity change,
  // and theme.js on grid sibling swatch hover. Put the names back after each rewrite.
  const hiddenLabel = (text) => {
    const span = document.createElement("span");
    span.className = "visually-hidden";
    span.textContent = text;
    return span;
  };

  const restoreButtonPrice = (price) => {
    const variantJson = price
      .closest("product-info")
      ?.querySelector("variant-selects [data-selected-variant]")?.textContent;
    if (variantJson) {
      const variant = JSON.parse(variantJson);
      price.classList.toggle("product__price--sale", variant.compare_at_price > variant.price);
    }

    const compare = price.querySelector(":scope > s");
    if (!compare) return;
    if (!price.querySelector(":scope > .visually-hidden")) {
      price.prepend(hiddenLabel(`${price.dataset.saleLabel} `));
    }
    if (!compare.querySelector(".visually-hidden")) {
      compare.prepend(hiddenLabel(`${price.dataset.regularLabel} `));
    }
  };

  const restoreGridPrice = (price) => {
    const newPrice = price.querySelector(".new-price");
    const oldPrice = price.querySelector(".old-price");
    if (!newPrice || !oldPrice) return;
    if (!newPrice.querySelector(".visually-hidden")) {
      newPrice.prepend(hiddenLabel(`${price.dataset.saleLabel} `));
    }
    if (!oldPrice.querySelector(".visually-hidden")) {
      oldPrice.prepend(hiddenLabel(`${price.dataset.regularLabel} `));
    }
  };

  const restore = (price) => {
    if (!price.dataset.saleLabel) return;
    // updateButtonPrice() writes `price <s>compare</s>` into the first
    // [data-product-price], which is the cart-bar span when
    // atc_show_product_price is off.
    if (price.matches(".btn__price, .cart-bar [data-product-price]")) restoreButtonPrice(price);
    else restoreGridPrice(price);
  };

  // Both bundles rewrite the price element's own innerHTML, so only records
  // whose target is a [data-product-price] matter. Observing the document
  // covers product-info and grid items added or replaced later. restore() is
  // a no-op once the names are present, so its own mutations settle.
  new MutationObserver((mutations) => {
    const prices = new Set();
    for (const { target } of mutations) {
      if (target.matches?.("[data-product-price]")) prices.add(target);
    }
    prices.forEach(restore);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.querySelectorAll(".btn__price[data-product-price]").forEach(restore);
})();
